export const categories = {
    bio: {
        // full_name: "Full Name",
        fathers_name: "Father's Name",
        gender: "Gender",
        region_of_birth: "Place of Birth",
        marital_status: "Marital Status Since",

    },
    contact: {
        personal_mobile_no: "Personal Mobile Number",
        personal_email_id: "Personal Email ID"
    },
    address: {
        address: "Current Address",

    },
    // education: {
    //     education: "Education",
    // },
    // work: {
    //     group_company: "Company Name"
    // },
    // job: {
    //     employee_id: "Employee ID",
    //     date_of_joining: "Date of Joining",
    //     confirmation_status: "Probation Period",
    // },
    manager: {
        location: "Location",
        attendance_shift: "Attendance Shift"
    },
};
